import React from "react";
import { Link } from "react-router-dom";
import Seo from "../Components/seo/Seo";

const NotFoundPage = () => {
  return (
    <div className="eb-container eb-section">
      <Seo title="404" description="The page you’re looking for could not be found." />
      <div className="grid items-center gap-10 lg:grid-cols-2">
        <div>
          <div className="eb-pill">404</div>
          <h1 className="mt-4 eb-h1">Page not found</h1>
          <p className="mt-4 text-lg eb-muted">
            Sorry—this page doesn’t exist. Use the navigation or go back to the homepage.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/" className="eb-btn-primary">
              Take me home
            </Link>
            <Link to="/Contact" className="eb-btn-ghost">
              Contact us
            </Link>
          </div>
        </div>

        <div className="eb-card overflow-hidden">
          <img
            src="Assets/home-img.webp"
            alt="EasyBooks"
            className="h-[320px] w-full object-cover sm:h-[420px]"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
